import React, { useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { registerGsapPlugins } from "utils/gsap.js";
import { graphql } from "gatsby";
import { useStaticQuery } from "gatsby";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
//assets
import doodle from "assets/svg/doodle-1.svg";
import doodleCircle from "assets/svg/doodle-footer.svg";

//styles
import typographySizes from "styles/typographySizes.js";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery.js";
import colors from "styles/colors.js";

//components
import TextWithLineBreaks from "components/global/typography/TextWithLineBreaks.js";
import MainWrapper from "components/global/MainWrapper.js";
import ServicesItem from "components/home/services/ServicesItem.js";
import BtnSec from "components/global/BtnSec.js";
import Body from "components/global/typography/text/Body.js";
import PlayBtn from "components/home/header/PlayBtn.js";
import Media from "components/global/Media.js";
import Works from "components/global/works/Works.js";

const Wrapper = styled.footer`
  margin-top: 10rem;
  height: 90dvh;

  /* -webkit-clip-path: ellipse(70% 60% at 50% 60%);
  clip-path: ellipse(70% 60% at 50% 60%); */
  -webkit-clip-path: ellipse(60% 60% at 50% 70%);
  clip-path: ellipse(60% 60% at 50% 70%);
  background-color: ${colors.purple};

  @media all and (max-width: ${mediaQuery.tablet}) {
    height: initial !important;
    -webkit-clip-path: ellipse(80% 60% at 50% 70%);
    clip-path: ellipse(80% 60% at 50% 70%);
  }

  ${MainWrapper} {
    display: flex;
    flex-direction: column-reverse;
    gap: 20dvh;
    padding-bottom: 2.4rem;

    @media all and (max-width: ${mediaQuery.tablet}) {
      gap: 0rem;
    }
  }
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5rem;
  align-items: center;
  justify-content: center;
  @media all and (max-width: ${mediaQuery.tablet}) {
  margin: 25rem 0 11rem 0;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 2rem;

  @media all and (max-width: ${mediaQuery.tablet}) {
    flex-direction: column;
  }
`;

const Titlerapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 1 0;


  @media all and (max-width: ${mediaQuery.tablet}) {
    order: -1;
    gap: 6rem;
    margin-bottom: 3.6rem;
  }
`;

const Title = styled.h3`
  font-size: ${typographySizes.text.tekstSize7.size.desktop}rem;
  line-height: ${typographySizes.text.tekstSize7.lineHeight};
  color: ${colors.dark};
  text-align: center;
  flex: 1 1 0;
  min-width: 0;
  position: relative;

  img {
    position: absolute;
    bottom: 0;
    right: 30%;
    transform: translate(50%, 100%);
    z-index: -1;

    @media all and (max-width: ${mediaQuery.desktop}) {
   
      font-size: ${typographySizes.text.tekstSize7.size.mobile}rem;
      line-height: ${typographySizes.text.tekstSize7.lineHeight};
    }
  }
`;

const StyledBtn = styled(BtnSec)`
display: none;
  &.mobile-hidden {
  display: block;
  }

  @media all and (max-width: ${mediaQuery.tablet}) {
    display: block;
    &.mobile-hidden {
      display: none;
    }
  }
`;

const Mail = styled.a`
  font-size: ${typographySizes.text.tekstSize5.size.desktop}rem;
  line-height: ${typographySizes.text.tekstSize5.lineHeight};
  color: ${colors.dark};
  flex: 1 1 0;
  min-width: 0;
  font-family: "Trash", sans-serif;
  text-align: center;

  @media all and (max-width: ${mediaQuery.desktop}) {
    font-size: ${typographySizes.text.tekstSize5.size.mobile}rem;
    line-height: ${typographySizes.text.tekstSize5.lineHeight};
  }
`;

const Subtitle = styled.h4`
  font-size: ${typographySizes.text.tekstSize5.size.desktop}rem;
  line-height: ${typographySizes.text.tekstSize5.lineHeight};
  color: ${colors.dark};
  flex: 1 1 0;
  min-width: 0;
  font-family: "Trash", sans-serif;
  text-align: center;

  @media all and (max-width: ${mediaQuery.desktop}) {
    font-size: ${typographySizes.text.tekstSize3.size.desktop}rem;
    line-height: ${typographySizes.text.tekstSize3.lineHeight};
  }
`;

const BotomLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

`;

const SocialMedia = styled.div`
  display: flex;
  gap: 0.8rem;
  justify-content: center;
  align-items: center;
`;

const SocialMediaItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  padding: 0.4rem;
  border-radius: 0.2rem;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
  }
`;

const PagesWrapper = styled.div`
  display: flex;
  gap: 2.4rem;
  justify-content: center;
  align-items: center;
`;

const PageItem = styled(Link)`
  font-size: ${typographySizes.text.tekstSize1.size.desktop}rem;
  line-height: ${typographySizes.text.tekstSize1.lineHeight};
  color: ${colors.dark};
  text-align: center;
  text-decoration: none;
  transition: all 0.3s ease-in-out;

  &:hover {
    opacity: 0.5;
    transition: all 0.3s ease-in-out;
  }
`;

const FooterLink = styled.a`
  font-size: ${typographySizes.text.tekstSize0.size.desktop}rem;
  line-height: ${typographySizes.text.tekstSize0.lineHeight};
  color: ${colors.dark};
  text-align: center;
  text-decoration: none;
  transition: all 0.3s ease-in-out;


&:hover {
  opacity: 0.5;
  transition: all 0.3s ease-in-out;
  }
`;

const Footer = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      strapiFooter {
        Title
        Subtitle
        Mail
        Book_a_call_link
        Social_media {
          Link
          Icon {
            localFile {
              url
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
  `);
  const footerRef = useRef(null);
  const location = useLocation();

  const isTabletDown = () => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(`(max-width: ${mediaQuery.tablet})`).matches;
  };

  useEffect(() => {
    const footerElement = footerRef.current;
    if (!footerElement) return;

    registerGsapPlugins();

    const ctx = gsap.context(() => {
      gsap.set(footerElement, {
        clipPath: "ellipse(110% 60% at 50% 60%)",
        WebkitClipPath: "ellipse(110% 60% at 50% 60%)",
      });

      const mobileClipPath = "ellipse(95% 60% at 50% 60%)";
      const defaultClipPath = "ellipse(60% 60% at 50% 70%)";
      const targetClipPath = isTabletDown() ? mobileClipPath : defaultClipPath;

      gsap.to(footerElement, {
        clipPath: targetClipPath,
        WebkitClipPath: targetClipPath,
        scrollTrigger: {
          trigger: footerElement,
          start: "top bottom",
          end: "bottom bottom",
          scrub: true,
        },
      });
    }, footerElement);

    const refreshId = requestAnimationFrame(() => {
      ScrollTrigger.refresh();
    });

    return () => {
      cancelAnimationFrame(refreshId);
      ctx.revert();
    };
  }, [location.pathname]);

  return (
    <Wrapper id="footer" ref={footerRef}>
      <MainWrapper>
        <BotomLinks>
          <SocialMedia>
            {data.strapiFooter.Social_media.map((item, index) => (
              <SocialMediaItem
                key={index}
                href={item.Link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Media media={item.Icon} alt={item.Icon.localFile.url} />
              </SocialMediaItem>
            ))}
          </SocialMedia>
          <PagesWrapper>
            <PageItem to="/">Home</PageItem>
            <PageItem to="/portfolio">Portfolio</PageItem>
            <PageItem to="/about">About</PageItem>
            <PageItem to="/services">Services</PageItem>
          </PagesWrapper>
        
    <FooterLink href="https://we3studio.pl" target="_blank" rel="noopener noreferrer">well designed by: we3studio.pl</FooterLink>
          
        </BotomLinks>
        <MainContent>
          <TextWrapper>
            <Mail href={`mailto:${data.strapiFooter.Mail}`}>
              {data.strapiFooter.Mail}
            </Mail>
            <Titlerapper>
              <Title>
                {data.strapiFooter.Title}{" "}
                <img src={doodleCircle} alt="" aria-hidden="true" />
              </Title>
              <StyledBtn href={data.strapiFooter.Book_a_call_link}>
                Book a call
              </StyledBtn>
            </Titlerapper>
            <Subtitle>
              <TextWithLineBreaks text={data.strapiFooter.Subtitle} />
            </Subtitle>
          </TextWrapper>
          <StyledBtn className="mobile-hidden" href={data.strapiFooter.Book_a_call_link}>
            Book a call
          </StyledBtn>
        </MainContent>
      </MainWrapper>
    </Wrapper>
  );
};

export default Footer;
